import {Card, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import DateHora from '../../../utils/dateHora'

export default function FichaSolicitacaoAnalise({ solicitacaoAnalise}) {
    return (
        <Card style={{ padding: 20, position: 'relative' }}>

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'SOLICITAÇÃO DE ANÁLISE'}
            />

            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Estado:</strong> {solicitacaoAnalise?.status ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Numero de registo:</strong> {solicitacaoAnalise?.numero ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Solicitado por:</strong> {solicitacaoAnalise?.remetidoPor?.nome ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Tipo de remetente:</strong> {solicitacaoAnalise?.tipoRemetente ?? '####'}</Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Remetente</strong> </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Nome: {solicitacaoAnalise?.remetidoPor.nome ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">NIF / B.I: {solicitacaoAnalise?.remetidoPor.bi ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Telefone: {solicitacaoAnalise?.remetidoPor.tel ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">E-mail: {solicitacaoAnalise?.remetidoPor.email ?? '####'} </Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Entidade</strong> </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Nome: {solicitacaoAnalise?.nome ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">NIF / B.I: {solicitacaoAnalise?.nifBi ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Telefone: {solicitacaoAnalise?.tel ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">E-mail: {solicitacaoAnalise?.email ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">provincia: {solicitacaoAnalise?.provincia ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Município: {solicitacaoAnalise?.municipio ?? '####'} </Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Quantidade de produtos:</strong> {solicitacaoAnalise?.productos?.length ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Grau de urgência:</strong> {solicitacaoAnalise?.grauUrgencia ?? 'Urgente'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Solicitação:</strong> <DateHora date={solicitacaoAnalise.createdAt} /></Typography>

            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Justificativa:</strong> {solicitacaoAnalise?.justificativa ?? '####'}</Typography>
        </Card>
    )
}
